module.exports = __webpack_public_path__ + "static/media/Card5.4fce1593.png";